/* KETTLER — Kaufzone (PDP Zone 1)
 *
 * Galerie, Variantenwechsel, Schwebeleiste und die Karte „Passt dazu".
 *
 * Der Kauf selbst gehört dem Theme-Formular in <product-form-component>.
 * Dieses Skript zeigt danach die Rückmeldung „Hinzugefügt" und legt den
 * optionalen Artikel aus „Passt dazu" nach.
 */
(function () {
  'use strict';

  var SCHMAL = 900;

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function init(section) {
    var id = section.id.replace('kaufbox-', '');
    var datenTag = document.querySelector('[data-kettler-varianten="' + id + '"]');
    var varianten = [];
    try { varianten = JSON.parse(datenTag.textContent); } catch (e) { varianten = []; }

    var form = section.querySelector('form[action*="/cart/add"]');
    var idFeld = section.querySelector('.k-varid');
    var cta = section.querySelector('.k-cta');
    var sticky = document.querySelector('.kettler-sticky[data-sticky-for="' + id + '"]');
    var stickyPruefen = null;

    /* ---------- Galerie ---------- */
    var ansichten = section.querySelectorAll('.k-view');
    var thumbs = section.querySelectorAll('.k-thumb');
    function zeige(i) {
      ansichten.forEach(function (v) {
        var sichtbar = v.dataset.view === String(i);
        v.style.display = sichtbar ? 'block' : 'none';
        /* Ein weggeblendetes Video liefe sonst unsichtbar mit Ton weiter. */
        if (!sichtbar) {
          var vid = v.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
      });
      thumbs.forEach(function (t) {
        var aktiv = t.dataset.view === String(i);
        t.style.borderColor = aktiv ? '#211C16' : 'rgba(33,28,22,0.10)';
        t.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { zeige(t.dataset.view); });
    });

    /* Galerie je Farbe: Ansichten und Thumbs tragen data-farbe (Liquid-Snippet
       kettler-media-farbe). Gezeigt werden die Medien der gewählten Farbe plus
       farbneutrale (ohne data-farbe-Wert), begrenzt auf data-galerie-max.
       Hat eine Farbe kein einziges zugeordnetes Medium, bleibt alles sichtbar. */
    var farbOption = Number(section.dataset.farbOption);
    var galerieMax = Number(section.dataset.galerieMax) || 12;
    var thumbGrid = section.querySelector('.k-thumbs');
    function galerieFilter(farbe, mediaId) {
      var hatFarbe = false;
      ansichten.forEach(function (v) { if (farbe && v.dataset.farbe === farbe) hatFarbe = true; });
      var sichtbar = 0, erste = null, ersteFarbe = null, variantenBild = null;
      ansichten.forEach(function (v) {
        var f = v.dataset.farbe;
        /* '#fremd': Bild zeigt eine Farbe, die es bei diesem Produkt nicht gibt → nie. */
        var passt = f !== '#fremd' && (!farbe || !hatFarbe || !f || f === farbe);
        if (passt && sichtbar >= galerieMax) passt = false;
        v.dataset.aktiv = passt ? '1' : '0';
        if (passt) {
          sichtbar++;
          if (erste === null) erste = v.dataset.view;
          if (ersteFarbe === null && f === farbe) ersteFarbe = v.dataset.view;
          if (mediaId && v.dataset.mediaId === String(mediaId)) variantenBild = v.dataset.view;
        }
      });
      if (variantenBild !== null) erste = variantenBild;
      else if (ersteFarbe !== null) erste = ersteFarbe;
      thumbs.forEach(function (t) {
        var ziel = section.querySelector('.k-view[data-view="' + t.dataset.view + '"]');
        var an = !ziel || ziel.dataset.aktiv !== '0';
        t.style.display = an ? '' : 'none';
      });
      if (thumbGrid) {
        var n = 0; thumbs.forEach(function (t) { if (t.style.display !== 'none') n++; });
        /* Handy: eine wischbare Reihe statt drei Zeilen Kacheln, die den Titel nach unten schieben. */
        var handy = window.matchMedia('(max-width: 749px)').matches;
        thumbGrid.style.gridTemplateColumns = handy ? 'repeat(' + Math.max(1, n) + ',64px)' : 'repeat(' + Math.max(1, Math.min(n, 5)) + ',1fr)';
        thumbGrid.style.overflowX = handy ? 'auto' : '';
        thumbGrid.style.scrollSnapType = handy ? 'x proximity' : '';
        thumbGrid.style.paddingBottom = handy ? '4px' : '';
        thumbGrid.style.display = n > 1 ? 'grid' : 'none';
      }
      if (erste !== null) zeige(erste);
    }
    var zeigeOhneFilter = zeige;
    zeige = function (i) {
      var ziel = section.querySelector('.k-view[data-view="' + i + '"]');
      if (ziel && ziel.dataset.aktiv === '0') return;
      zeigeOhneFilter(i);
    };

    /* ---------- Variantenwechsel ---------- */
    function gewaehlteWerte() {
      var werte = [];
      section.querySelectorAll('.k-varinput:checked').forEach(function (r) {
        werte[Number(r.dataset.opt)] = r.value;
      });
      return werte;
    }

    function passendeVariante(werte) {
      for (var i = 0; i < varianten.length; i++) {
        var v = varianten[i];
        var treffer = true;
        for (var k = 0; k < werte.length; k++) {
          if (werte[k] !== undefined && v.options[k] !== werte[k]) { treffer = false; break; }
        }
        if (treffer) return v;
      }
      return null;
    }

    function uebernehmen(v) {
      if (!v) return;
      if (idFeld) idFeld.value = v.id;
      if (farbOption >= 0) galerieFilter(v.options[farbOption], v.featured_media && v.featured_media.id);

      section.querySelectorAll('.k-price').forEach(function (e) { e.textContent = euro(v.price); });
      if (sticky) sticky.querySelectorAll('.k-price').forEach(function (e) { e.textContent = euro(v.price); });

      var uvp = section.querySelector('.k-uvp');
      var rabatt = section.querySelector('.k-rabatt');
      var sale = section.querySelector('.k-sale');
      var hatUvp = v.compare_at_price && v.compare_at_price > v.price;
      if (uvp) uvp.style.display = hatUvp ? '' : 'none';
      if (hatUvp) {
        if (uvp) uvp.textContent = (uvp.dataset.text || 'UVP') + ' ' + euro(v.compare_at_price);
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (rabatt) rabatt.textContent = '−' + pct + ' %';
        if (sale) sale.lastElementChild.textContent = '−' + pct + ' %';
      }
      if (rabatt) rabatt.style.display = hatUvp ? '' : 'none';
      if (sale) sale.style.display = hatUvp ? 'flex' : 'none';

      document.querySelectorAll('.k-varname').forEach(function (e) {
        e.textContent = v.options[Number(e.dataset.opt || 0)] || v.options[0];
      });
      section.querySelectorAll('.k-optlabel').forEach(function (e) {
        e.textContent = v.options[Number(e.dataset.opt)];
      });

      var lager = section.querySelector('.k-lagertext');
      var punkt = section.querySelector('.k-lager span');
      if (lager) {
        var zusatz = lager.dataset.lieferzeit || '';
        lager.textContent = v.available ? ((lager.dataset.textAufLager || 'Auf Lager') + (zusatz ? ' — ' + zusatz : '')) : (lager.dataset.textNichtVerfuegbar || 'Derzeit nicht verfügbar');
      }
      if (punkt) punkt.style.background = v.available ? '#3E7113' : 'rgba(33,28,22,.40)';
      if (cta) {
        cta.disabled = !v.available;
        cta.textContent = v.available ? (cta.dataset.textWarenkorb || 'In den Warenkorb') : (cta.dataset.textAusverkauft || 'Ausverkauft');
      }
      var express = section.querySelector('.k-express');
      if (express) express.hidden = !v.available;
      var lieferzeit = section.querySelector('.k-lieferzeit');
      if (lieferzeit) lieferzeit.hidden = !v.available;
      section.querySelectorAll('[data-nur-lieferbar]').forEach(function (e) { e.hidden = !v.available; });
      if (stickyPruefen) stickyPruefen();
    }

    if (farbOption >= 0) {
      var start = passendeVariante(gewaehlteWerte());
      /* Nur eine Variante: Startbild ist immer das erste Produktbild, nicht das Variantenbild
         (Franzi 09.10.2026: geaenderte Bildreihenfolge kam sonst nicht an). */
      if (varianten.length === 1) galerieFilter(null, null);
      else if (start) galerieFilter(start.options[farbOption], start.featured_media && start.featured_media.id);
    }
    section.querySelectorAll('.k-varinput').forEach(function (r) {
      r.addEventListener('change', function () {
        section.querySelectorAll('.k-var').forEach(function (l) {
          var eingabe = l.querySelector('.k-varinput');
          l.style.borderColor = eingabe && eingabe.checked ? '#211C16' : 'rgba(33,28,22,0.22)';
        });
        uebernehmen(passendeVariante(gewaehlteWerte()));
      });
    });

    /* ---------- Karte „Passt dazu" ---------- */
    var cs = section.querySelector('.k-csinput');
    var csBox = section.querySelector('.k-csbox');
    if (cs && csBox) {
      cs.addEventListener('change', function () {
        csBox.style.borderColor = cs.checked ? '#211C16' : 'rgba(33,28,22,0.22)';
        csBox.style.background = cs.checked ? '#FFCC00' : '#FFFFFF';
        csBox.textContent = cs.checked ? '✓' : '';
      });
    }

    /* ---------- Absenden ---------- */
    var stickyCta = sticky ? sticky.querySelector('.k-stickycta') : null;
    var ladeTimer = null;

    /* Sofort sichtbar, dass der Klick angekommen ist: Shopify antwortet erst nach ~1 s.
       pointer-events: none (CSS .k-laedt) verhindert Mehrfachklicks bis dahin. */
    function laedt(an) {
      [cta, stickyCta].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('k-laedt', an);
        b.setAttribute('aria-busy', an ? 'true' : 'false');
      });
      clearTimeout(ladeTimer);
      if (an) ladeTimer = setTimeout(function () { laedt(false); }, 8000);
    }

    function rueckmeldung() {
      var text = (cta && cta.dataset.textHinzugefuegt) || '✓ Hinzugefügt';
      [cta, stickyCta].forEach(function (b) {
        if (!b) return;
        var alt = b.textContent;
        b.textContent = text;
        setTimeout(function () { b.textContent = alt; }, 2200);
      });
    }

    /* Den Hauptartikel legt allein <product-form-component> an; ein zweiter fetch
       daneben würde ihn doppelt in den Warenkorb legen. Der optionale Artikel aus
       „Passt dazu" folgt erst nach cart:update, damit nie zwei Anfragen gleichzeitig laufen. */
    if (form) {
      form.addEventListener('submit', function () {
        var zusatz = cs && cs.checked && cs.dataset.variant ? Number(cs.dataset.variant) : 0;
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        laedt(true);
        function fertig(ev) {
          document.removeEventListener('cart:update', fertig);
          document.removeEventListener('cart:error', fertig);
          laedt(false);
          if (ev.type === 'cart:error' || (ev.detail && ev.detail.data && ev.detail.data.didError)) return;
          rueckmeldung();
          if (!zusatz) return;
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: zusatz, quantity: 1 }] })
          }).then(function () {
            return fetch(root + 'cart.js').then(function (r) { return r.json(); });
          }).then(function (cart) {
            /* Zähler und Warenkorb-Lade des Themes auf den neuen Stand bringen */
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'kettler-passt-dazu', data: { itemCount: cart.item_count, source: 'kettler-passt-dazu' } }
            }));
          });
        }
        document.addEventListener('cart:update', fertig);
        document.addEventListener('cart:error', fertig);
      });
    }

    if (sticky) {
      if (stickyCta && form) {
        stickyCta.addEventListener('click', function () {
          if (stickyCta.classList.contains('k-laedt')) return;
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
      var ctaSichtbar = true;
      var schmal = window.innerWidth < SCHMAL;
      function pruefe() {
        sticky.hidden = !(schmal && !ctaSichtbar && !(cta && cta.disabled));
        document.documentElement.classList.toggle('k-sticky-an', !sticky.hidden);
      }
      stickyPruefen = pruefe;
      window.addEventListener('resize', function () {
        schmal = window.innerWidth < SCHMAL;
        pruefe();
      });
      /* Pufferzone statt harter Kante: Safari auf dem iPhone blendet beim Scrollen die
         Adressleiste ein und aus, die Fensterhöhe springt dabei um 50–80 px. Mit der Kante
         bei 0 px ging die Leiste dadurch im Wechsel an und aus (Flimmern). Jetzt erscheint
         sie erst, wenn der Button ganz aus dem Bild ist, und verschwindet erst, wenn er
         mindestens PUFFER px weit im Bild steht. */
      var PUFFER = 100;
      var geplant = false;
      function lage() {
        geplant = false;
        if (!cta) return;
        var r = cta.getBoundingClientRect();
        var hoehe = window.innerHeight;
        if (ctaSichtbar) {
          if (r.top > hoehe || r.bottom < 0) ctaSichtbar = false;
        } else if (r.top < hoehe - PUFFER && r.bottom > PUFFER) {
          ctaSichtbar = true;
        }
        pruefe();
      }
      function planen() {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(lage);
      }
      window.addEventListener('scroll', planen, { passive: true });
      window.addEventListener('resize', planen);
      lage();
    }
  }

  function start() {
    document.querySelectorAll('[data-kettler-zone="kaufzone"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
